import React from 'react';
import { Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import Loading from './Loading';
import LoadingError from './LoadingError';
import axiosInstance from '../actions/AxiosInstance';
import api from '../actions/EndPoints';
import { log } from '../Utils';


export default function YodleeLinkAccountView({ action, indexState }) {
    const ref = React.createRef();
    const [loading, setLoading] = React.useState(true);
    const [loadingError, setLoadingError] = React.useState(false);
    const [formAction, setFormAction] = React.useState(null);
    const [rSession, setRSession] = React.useState(null);
    const [accessToken, setAccessToken] = React.useState(null);
    const [appID, setAppID] = React.useState(null);

    const Form = React.forwardRef(() => {
        log(console.log('formAction', formAction));
        log(console.log('rSession', rSession));
        log(console.log('accessToken', accessToken));
        log(console.log('appID', appID));
        return (
            <form
                action={formAction}
                ref={ref}
                name="externalAccountLaunchApplication"
                id="myForm"
                style={{ display: 'none' }}
                method="POST"
            >
                <input type="hidden" name="rsession" value={rSession} />
                <input type="hidden" name="token" value={accessToken} />
                <input type="hidden" name="app" value={appID} />
            </form>
        );
    });

    React.useEffect(() => {
        let isCancelled = false;
        const setYodleeSSOData = async () => {
            const apiKey = indexState.trpUserData.applicationConfig.apiKey;

            try {
                const yodleeSSOData = await axiosInstance.get(api.ssoYodleeAPI, {
                    headers: {
                        apiKey: `${apiKey}`,
                    }
                });
                if (yodleeSSOData) {
                    const { data } = yodleeSSOData;
                    const { yodleeAppAuthData } = data;
                    log(console.log('yodleeAppAuthData', yodleeAppAuthData));
                    setFormAction(yodleeAppAuthData.accessToken.accessTokens[0].url);
                    setRSession(yodleeAppAuthData.user.session.userSession);
                    setAccessToken(yodleeAppAuthData.accessToken.accessTokens[0].value);
                    setAppID(yodleeAppAuthData.accessToken.accessTokens[0].appId);
                    setLoading(false);
                }
            } catch (error) {
                log(console.log(error));
                setLoading(false);
                setLoadingError(true);
            }
        };

        if (!isCancelled) {
            setYodleeSSOData();
        }

        return () => {
            isCancelled = true;
        }
    }, []);

    React.useEffect(() => {
        if (ref?.current !== null) {
            document?.forms?.myForm?.submit();
        }
    }, [ref])

    return (
        <Box fixed sx={{ height: 600 }}>
            {loadingError &&
                (
                    <LoadingError />
                )
            }
            {loading &&
                (
                    <Loading headerText="Loading..." />
                )
            }
            {!loading && !loadingError &&
                (
                    <Form
                        ref={ref}
                        id="submitForm"
                        name="SAMLResponse"
                        action={action}
                    />
                )

            }
        </Box>
    );
}
